import licenseModule from '../../license.module';

export default licenseModule.component('licenseManageSubscriptionId', {
    template: require('./licenseManageSubscriptionId.component.html'),
    styleUrls: require('./licenseManageSubscriptionId.component.css'),
    controller: ['entitlementConstants', licenseManageSubscriptionIdComponent],
    bindings: {
        summaryDeviceIdTotal: '<',
        summaryPremiumUserIdTotal: '<',
        summaryDeviceIdUsage: '<',
        summaryPremiumUserIdUsage: '<',
        instanceName: '<',
        instanceMaxDevices: '<',
        instanceMaxUsers: '<',
        licenseMaxDevices: '<',
        licenseMaxUsers: '<',
        licenseSymmetric: '<',
        callback: '&'
    }
});

function licenseManageSubscriptionIdComponent(entitlementConstants) {
    var vm = this;
    vm.devicesLabel = entitlementConstants.devices;
    vm.platformUsersLabel = entitlementConstants.platformUsers;

    vm.min = 1;
    vm.changes = function() {
        var value = {
            license: {
                maxUsers: vm.licenseMaxUsers,
                maxDevices: vm.licenseMaxDevices
            },
            eula: vm.eula
        };
        vm.callback({ value: value });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-manage-subscription-id/licenseManageSubscriptionId.component.js